<template>
  <el-dialog
      :title="'编辑余额'"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
  >
    <el-form :model="form" ref="form" label-width="120px" size="medium">
      <el-form-item label="选择部门" prop="orgIds">
        <el-select
          v-model="form.orgIds"
          multiple
          filterable
          placeholder="请选择部门"
          style="width: 100%"
          :disabled="isEdit"
        >
          <el-option
            v-for="item in departmentList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="操作类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">直接修改余额</el-radio>
          <el-radio :label="1">追加余额</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="金额 (元)" prop="money">
        <el-input
          v-model="moneyYuan"
          type="number"
          placeholder="请输入金额"
          @input="handleMoneyInput"
        >
          <template slot="append">元</template>
        </el-input>
        <div style="font-size: 12px; color: #999; margin-top: 5px;">
          {{ form.type === 0 ? '将直接设置为' : '将在原基础上增加/减少' }}: {{ moneyYuan }} 元
        </div>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getFuncTree, getParkingBalanceList, setParkingBalance} from "./api/index";
import request from '@/utils/apiRequest';

export default {
  name: 'EditBalanceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedDepartments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      departmentList: [],
      form: {
        orgIds: [],
        money: 0,
        type: 0,
        remark: ''
      },
      moneyYuan: '',
      submitting: false,
      isEdit: false
    };
  },
  computed: {
    moneyFen() {
      const yuan = parseFloat(this.moneyYuan) || 0;
      return Math.round(yuan * 100);
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initData();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    initData() {
      // 加载部门列表
      this.loadDepartmentTree();
      
      // 如果有选中的部门，默认选中
      if (this.selectedDepartments && this.selectedDepartments.length > 0) {
        this.form.orgIds = this.selectedDepartments.map(item => item.id);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      
      // 重置表单
      this.form.money = 0;
      this.form.type = 0;
      this.form.remark = '';
      this.moneyYuan = '';
    },
    
    // 加载部门树
    loadDepartmentTree() {
      getParkingBalanceList()
          .then((res) => {
            this.departmentList = res.data.data || [];
            this.departmentList.forEach(item => item.parkingBalance /= 100)
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "查询失败", {
              type: "error",
            })
          });
      
      // getFuncTree()
      //   .then((res) => {
      //     this.departmentList = res.data || [];
      //   })
      //   .catch((err) => {
      //     this.$message.error('加载部门列表失败');
      //   });
    },
    
    // 金额输入处理
    handleMoneyInput(value) {
      // 只允许输入数字和小数点
      const reg = /^[0-9]*\.?[0-9]*$/;
      if (!reg.test(value)) {
        this.moneyYuan = value.replace(/[^0-9.]/g, '');
      }
    },
    
    handleClose() {
      this.$refs.form && this.$refs.form.clearValidate();
      this.$emit('update:visible', false);
    },
    
    handleSubmit() {
      if (this.form.orgIds.length === 0) {
        this.$message.warning('请至少选择一个部门');
        return;
      }
      
      const moneyValue = parseFloat(this.moneyYuan);
      if (isNaN(moneyValue) || moneyValue <= 0) {
        this.$message.warning('请输入有效的金额');
        return;
      }
      
      // 将金额转换为分
      this.form.money = Math.round(moneyValue * 100);
      
      this.submitting = true;
      
      setParkingBalance(this.form)
        .then((res) => {
          this.$message.success('操作成功');
          this.$emit('success');
          this.handleClose();
        })
        .catch((err) => {
          this.$message.error('操作失败');
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
